import { FC } from 'react'
import tw from 'tailwind-styled-components'
import { useTranslation } from 'next-i18next'
import { RepresentativeCountryFragment } from '@foros-fe/graphql'
import { ContactCard, Props as ContactCardProps } from './ContactCard'

const Wrapper = tw.div`flex-1 flex-col mb-16`
const Title = tw.p`font-poppins text-2xl mb-6`
const GridContainer = tw.div`grid grid-flow-row grid-cols-1 md:grid-cols-3 gap-8 md:gap-14`

export const CountryOffice: FC<
  Omit<RepresentativeCountryFragment, 'representatives'> & {
    representatives: ContactCardProps[]
  }
> = ({ countryCode, flagEmoji, representatives }) => {
  const { t } = useTranslation('enum')

  return (
    <Wrapper>
      <Title>
        {flagEmoji}
        &nbsp;
        {t(`CountryCode.${countryCode}`)}
      </Title>
      <GridContainer>
        {representatives.map((c, i) => (
          <ContactCard key={`ck-${i}`} {...c} />
        ))}
      </GridContainer>
    </Wrapper>
  )
}
